import { render, staticRenderFns } from "./industryMessage.vue?vue&type=template&id=ce1b807a&scoped=true&"
import script from "./industryMessage.vue?vue&type=script&lang=js&"
export * from "./industryMessage.vue?vue&type=script&lang=js&"
import style0 from "./industryMessage.vue?vue&type=style&index=0&id=ce1b807a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1b807a",
  null
  
)

export default component.exports